import objectiveBanner from '../assets/images/objetivo.jpg';
import missionBanner from '../assets/images/missao.jpg';
import valuesBanner from '../assets/images/valores.jpg';

const mock = [{
  title: 'Objetivo',
  thumb: objectiveBanner,
  html: '<p>Criar um espaço coletivo de livre acesso e compartilhamento de conteúdo sobre direitos autorais e suas intersecções com áreas de conhecimento importantes para o desenvolvimento científico, cultural, tecnológico e econômico.</p>'
}, {
  title: 'Missão',
  thumb: missionBanner,
  html: '<p>Democratizar os Direitos Autorais, assegurar o acesso público a materiais sobre a temática e viabilizar a formação e o desenvolvimento do pensamento crítico sobre direitos autorais e políticas relacionadas.</p>'
}, {
  title: 'Valores',
  thumb: valuesBanner,
  html: '<ul><li>Democratizar conhecimento sobre os direitos autorais</li><li>Promover acesso à informação e cultura</li><li>Incentivar a informação e o desenvolvimento socioeconômico</li></ul>'
}];

export default mock;